import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  getAllTemplates(
    { state },
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.customLayout.templatesList}?pageNo=${pageNumber}&PageSize=${pageSize}&searchText=${value}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchLayoutDetails({ state }, { templateId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.customLayout.removeTemplate}/${templateId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  commitLayoutDesigner({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.customLayout.removeTemplate}`
    if(payload.templateId > 0) {
      return axios
      .put(url, payload, {
        headers: setHeaders()
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
    }
    else {
      return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
    }
  },
  removeLayoutTemplate({ state }, { templateId } = {}) {
    return axios
      .delete(
        `${appConfig.apiEndPoint}${endpoint.customLayout.removeTemplate}/${templateId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  verifyTemplateAssociation({state}, {templateId}={}){
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.customLayout.verifyTemplateAssociation}/${templateId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  }
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
